import React, { Fragment } from 'react';
import Button from '../next-ui/Button';
import Typography from '../next-ui/Typography';
import useConfirmDialogStore from './confirmDialog.store';
import { Dialog, Transition } from '@headlessui/react';
import { MdClose } from 'react-icons/md';

function ConfirmDialog(props) {
  const { open, title, message, updateConfirmation, buttonTitle } =
    useConfirmDialogStore();

  const handleClose = (e) => {
    updateConfirmation(false);
  };

  const handleConfirm = () => {
    updateConfirmation(true);
  };

  if (open && title && message && buttonTitle) {
    return (
      <Transition appear show={open} as={Fragment}>
        <Dialog
          as="div"
          open={open}
          className="relative z-2000"
          onClose={handleClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <div className="fixed inset-0 bg-black/25" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95">
                <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex items-center justify-start">
                    <Dialog.Title className="flex-1">
                      <Typography variant="h4">{title}</Typography>
                    </Dialog.Title>

                    <Button variant="icon" onClick={handleClose}>
                      <MdClose className="h-6 w-6" />
                    </Button>
                  </div>
                  <div className="mt-2 flex flex-col gap-4">
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      component="div">
                      {message}
                    </Typography>
                    <div className="flex w-full justify-end">
                      <Button
                        variant="filled"
                        color="primary"
                        onClick={handleConfirm}>
                        {buttonTitle}
                      </Button>
                    </div>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    );
  }
  return null;
}

export default ConfirmDialog;
